/* eslint-disable */
// @ts-nocheck
import { createLucideIcon } from 'lucide-react';

// Define the icon nodes
const iconNodes = [
  ["path", {"d":"M8.713 17.217A25 25 0 0 1 7.22 19.18C3.436 19.072 2 16.615 2 16.615a23 23 0 0 1 2.467-10.01 8.45 8.45 0 0 1 4.81-1.784l.513 1.184q1.099-.153 2.21-.159 1.116.004 2.22.154l.513-1.185a8.45 8.45 0 0 1 4.81 1.8 23 23 0 0 1 2.457 10s-1.436 2.457-5.22 2.565a24 24 0 0 1-1.467-1.954m3.313-1.487c-1.97.997-3.875 1.994-6.626 1.994s-4.656-.997-6.626-1.995M10 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0","strokeWidth":"1.5","key":"qa83be"}]
];

// Create and export the icon component
export const DiscordIcon = createLucideIcon("discord", iconNodes);
